/*
 * Layout Name: BespokeTestimonials
 * Desc:
 */
// libs
import React from "react"
import { Image } from "react-datocms"
import ReactMarkdown from "react-markdown"
import Link from "next/link"
// assets
import * as styles from "./BespokeTestimonials.module.scss"
import Section from "@components/structure/Section/Section"
// components
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import locationIcon from "@images/icons/locationMarkerWhite.svg"
import quoteMarkPink from "@images/pages/bespoke/quoteMarkPink.png"

const BespokeTestimonials = (props) => {
  const testimonials = props.testimonials.map((testimonial, i) => (
    <div key={i} className={styles.testimonial}>
      <Image data={testimonial.image.responsiveImage} pictureStyle={{ objectFit: "cover" }} />
      <div>
        <h2>{testimonial.title}</h2>
        <div className={styles.meta}>
          <span>
            <img src={locationIcon} alt="" />
            {testimonial.location}
          </span>
        </div>
        <div className={styles.description}>
          <span>
            <img src={quoteMarkPink} alt="" />
          </span>
          <ReactMarkdown>{testimonial.quote}</ReactMarkdown>
        </div>
        <h3>Suppliers to note</h3>
        <div className={styles.suppliers}>
          {testimonial.suppliers.map((supplier, i) => (
            <div key={i} className={styles.supplier}>
              <span className={styles.category}>{supplier.category}</span>
              {supplier.supplier ? (
                <Link href={`/supplier/${supplier.supplier.slug}`}>
                  <a>
                    <span className={styles.name}>{supplier.name}</span>
                  </a>
                </Link>
              ) : (
                <span className={styles.name}>{supplier.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  ))

  return (
    <section className={styles.BespokeTestimonials}>
      <SiteWrapper>
        <Section>
          <h1>{props.title}</h1>
          <div className={styles.testimonials}>{testimonials}</div>
        </Section>
      </SiteWrapper>
    </section>
  )
}

export default BespokeTestimonials
